<template>
  <QHeader v-if="$q.screen.xs" class="bg-white text-primary shadow-soft">
    <QToolbar class="dashboard-tabs">
      <QTabs align="justify">
        <QRouteTab
          no-caps
          :to="{ name: upcomingRoute }"
          :label="$t('ETAB.PAGES.DEMAND_DASHBOARD.@UPCOMING')"
        />
        <QRouteTab
          no-caps
          :to="{ name: inProgressRoute }"
          :label="$t('ETAB.PAGES.DEMAND_DASHBOARD.@IN_PROGRESS')"
        />
        <QRouteTab
          no-caps
          :to="{ name: planningRoute }"
          icon="icon-f-calendar"
        />
      </QTabs>
    </QToolbar>
  </QHeader>
</template>

<script>
import { ETAB_ROUTES } from "@etab/config";

export default {
  created() {
    this.upcomingRoute = ETAB_ROUTES.dashboard.tabs.upcoming.name;
    this.inProgressRoute = ETAB_ROUTES.dashboard.tabs.inProgress.name;
    this.planningRoute = ETAB_ROUTES.dashboard.planning.root.name;
  },
};
</script>

<style lang="scss">
.dashboard-tabs {
  padding: 0;
  .q-tabs {
    min-height: 50px;
    width: 100%;
    .q-tab .q-tab__label {
      font-size: 18px;
      @media screen and (max-width: 320px) {
        font-size: 14px;
      }
    }
  }
}
</style>
